'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n    flex-direction: column;\n  '], ['\n    flex-direction: column;\n  ']),
    _templateObject2 = _taggedTemplateLiteral(['\n      flex-direction: column;\n    '], ['\n      flex-direction: column;\n    ']),
    _templateObject3 = _taggedTemplateLiteral(['\n    display: none;\n  '], ['\n    display: none;\n  ']),
    _templateObject4 = _taggedTemplateLiteral(['\n      display: block;\n    '], ['\n      display: block;\n    ']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _UIFlex = require('UIComponents/layout/UIFlex');

var _UIFlex2 = _interopRequireDefault(_UIFlex);

var _SeatsPicker = require('../common/SeatsPicker');

var _SeatsPicker2 = _interopRequireDefault(_SeatsPicker);

var _BundlePage = require('./BundlePage');

var _Terms = require('self-service-api/constants/Terms');

var _ServicePlanButton = require('./ServicePlanButton');

var _ServicePlanButton2 = _interopRequireDefault(_ServicePlanButton);

var _MerchandiseIds = require('self-service-api/constants/MerchandiseIds');

var _AccordionTransition = require('UIComponents/transitions/AccordionTransition');

var _AccordionTransition2 = _interopRequireDefault(_AccordionTransition);

var _Editions = require('self-service-api/constants/Editions');

var Editions = _interopRequireWildcard(_Editions);

var _H = require('UIComponents/elements/headings/H1');

var _H2 = _interopRequireDefault(_H);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _responsiveBreakpoints = require('../../utils/responsiveBreakpoints');

var _responsiveBreakpoints2 = _interopRequireDefault(_responsiveBreakpoints);

var _ViewAllFeatures = require('pricing-pages-unified-ui/components/product-pages/ViewAllFeatures');

var _ViewAllFeatures2 = _interopRequireDefault(_ViewAllFeatures);

var _Hubs = require('self-service-api/constants/Hubs');

var _Hubs2 = _interopRequireDefault(_Hubs);

var _publicPageUrls = require('pricing-pages-unified-ui/utils/publicPageUrls');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var ButtonFlex = (0, _styledComponents2.default)(_UIFlex2.default).withConfig({
  displayName: 'ServiceHubBundle__ButtonFlex'
})(['', ';'], _responsiveBreakpoints2.default.phone(_templateObject));

var ButtonWrapper = _styledComponents2.default.div.withConfig({
  displayName: 'ServiceHubBundle__ButtonWrapper'
})(['width:100%;']);

var StyledAccordionTransition = (0, _styledComponents2.default)(_AccordionTransition2.default).withConfig({
  displayName: 'ServiceHubBundle__StyledAccordionTransition'
})(['overflow:visible !important;']);

var StyledH1 = (0, _styledComponents2.default)(_H2.default).withConfig({
  displayName: 'ServiceHubBundle__StyledH1'
})(['margin-bottom:8px !important;']);

var StyledFlex = (0, _styledComponents2.default)(_UIFlex2.default).withConfig({
  displayName: 'ServiceHubBundle__StyledFlex'
})(['&.bundle-flex{', '}'], _responsiveBreakpoints2.default.phone(_templateObject2));

var BundleSubtitle = _styledComponents2.default.div.withConfig({
  displayName: 'ServiceHubBundle__BundleSubtitle'
})(['', ' .bundle-flex &{display:none;', '}'], _responsiveBreakpoints2.default.phone(_templateObject3), _responsiveBreakpoints2.default.phone(_templateObject4));

function ServiceHubBundle(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle;

  var _useContext = (0, _react.useContext)(_BundlePage.BundleContext),
      state = _useContext.state,
      mergeState = _useContext.mergeState;

  var servicePlanSelected = state.servicePlanSelected,
      serviceUnits = state.serviceUnits;

  return _react2.default.createElement(
    'div',
    { className: 'm-bottom-12' },
    _react2.default.createElement(
      StyledFlex,
      { className: 'bundle-flex', justify: 'between' },
      _react2.default.createElement(
        StyledH1,
        null,
        title
      ),
      _react2.default.createElement(
        BundleSubtitle,
        null,
        subtitle
      ),
      _react2.default.createElement(
        'div',
        { className: 'm-top-2 m-right-2' },
        _react2.default.createElement(_ViewAllFeatures2.default, {
          trackingPrefix: 'bundle',
          hub: _Hubs2.default.HUB_SERVICE,
          use: 'inline',
          gaClassName: (0, _publicPageUrls.getGAClassName)('bundle-pricing-servicecompare')
        })
      )
    ),
    _react2.default.createElement(
      BundleSubtitle,
      null,
      subtitle
    ),
    _react2.default.createElement(
      ButtonFlex,
      { className: 'm-top-6' },
      _react2.default.createElement(
        ButtonWrapper,
        { className: 'm-right-2' },
        _react2.default.createElement(_ServicePlanButton2.default, {
          edition: Editions.STARTER,
          merchandiseId: _MerchandiseIds.PRODUCT_SERVICE_STARTER
        })
      ),
      _react2.default.createElement(
        ButtonWrapper,
        { className: 'm-right-2' },
        _react2.default.createElement(_ServicePlanButton2.default, {
          edition: Editions.PROFESSIONAL,
          merchandiseId: _MerchandiseIds.PRODUCT_SERVICE_PROFESSIONAL
        })
      ),
      _react2.default.createElement(
        ButtonWrapper,
        null,
        _react2.default.createElement(_ServicePlanButton2.default, {
          edition: Editions.ENTERPRISE,
          merchandiseId: _MerchandiseIds.PRODUCT_SERVICE_ENTERPRISE
        })
      )
    ),
    _react2.default.createElement(
      StyledAccordionTransition,
      { open: !!servicePlanSelected },
      _react2.default.createElement(
        'div',
        { className: 'm-top-10' },
        _react2.default.createElement(_SeatsPicker2.default, {
          merchandiseId: servicePlanSelected,
          additionalUnitQuantity: serviceUnits,
          onChange: function onChange(value) {
            return mergeState({ serviceUnits: value });
          },
          term: _Terms.MONTHLY
        })
      )
    )
  );
}

exports.default = ServiceHubBundle;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/components/bundle-page/ServiceHubBundle.js
// module id = 703
// module chunks = 3 4